import request from '@/utils/request'
import qs from 'qs'

// login 登陆
export function login (data) {
  return request({
    url: '/api/v2/login',
    method: 'post',
    data
  })
}

// logout 退出
export function logout () {
  return request({
    url: '/api/v2/logout',
    method: 'post'
  })
}

// refreshtoken 刷新token
export function refreshtoken (data) {
  return request({
    url: '/refreshtoken',
    method: 'post',
    data
  })
}

// getInfo 获取用户基本信息
export function getInfo () {
  return request({
    url: '/api/v1/getinfo',
    method: 'get'
  })
}

// 查询用户个人信息
export function getUserProfile () {
  return request({
    url: '/api/v2/user/profile',
    method: 'get'
  })
}

// 手机验证码登录
export function phoneLogin (data) {
  return request({
    url: '/api/v2/t-user/sms/login',
    method: 'post',
    data: qs.stringify(data),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 获取在线设备列表
export function getOnlineDevices () {
  return request({
    url: '/api/v2/user/online-devices',
    method: 'get'
  })
}

// 踢出设备
export function kickDevice (sessionId) {
  return request({
    url: '/api/v2/user/kick-device',
    method: 'post',
    data: {
      sessionId
    }
  })
}

// 获取登录通知
export function getLoginNotify () {
  return request({
    url: '/api/v2/user/login-notify',
    method: 'get'
  })
}
